<template>
  <div class="content">
    <el-form :model="propsParams" ref="ruleForm" label-width="100px" class="demo-ruleForm">
      <el-form-item label="联系电话：" prop="oldPhone" label-width="130px">
				<el-input v-model="propsParams.oldPhone" style="width:260px" placeholder="联系电话"></el-input>
      </el-form-item>
      <el-form-item label="新联系电话：" prop="phone" label-width="130px">
				<el-input v-model="propsParams.phone" style="width:260px" placeholder="新联系电话"></el-input>
      </el-form-item>
      <el-form-item label="验证码：" prop="code" label-width="130px">
				<el-input v-model="propsParams.code" style="width:120px" placeholder="验证码"></el-input>
        <div class="input-code">
          <span v-show="show" @click="getCode" class="opt-a">获取验证码</span>
          <span v-show="!show" class="count opt-a">{{count}}s后可重发</span>
        </div>
      </el-form-item>
      <el-button type="primary" class="buttonclass" @click="handleSubmit">提交</el-button>
    </el-form>
  </div>
</template>
<script>
import { sendSms,bindPhone } from "@/api/api.js"; //发送验证码,重新绑定手机号
export default {
  data() {
    return {
      propsParams:{
        oldPhone:""
      },
      // 倒计时的显示
      show: true,
      count: "",
      timer: null,
    };
  },
  computed: {},
  methods: {
    // 提交
    handleSubmit(){
      let params = {
        phone: this.propsParams.phone,
        code:this.propsParams.code
      };
      bindPhone(params).then(res => {
        if(res.data.code == 200){
          this.$notify({
            title: "成功",
            message: "修改手机号成功",
            type: "success",
            duration: 1500
          });
          this.$router.push('/user/account')
        }else{
          this.$message.error(res.data.message);
        }
      })
    },
    // 发送验证码
    getCode(){
      let params = {
        phone: this.propsParams.phone
      };
      sendSms(params).then(res => {
        if(res.data.code == 200){
          const TIME_COUNT = 60;
          if ( !this.timer && this.propsParams.phone) {
            this.count = TIME_COUNT;
            this.show = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              }else{
                this.show = true;
                clearInterval(this.timer);
                this.timer = null
              }
            },1000)
          }
        }else{
          this.$message.error(res.data.message);
        }
      })
    }
  },
  mounted() {

  },
  created() {
    const phone = this.$route.params && this.$route.params.phone;
    const hiddenPhone = phone.substr(0,3)+"****"+phone.substr(7);    
    this.propsParams.oldPhone = hiddenPhone
  }
};
</script>
<style scoped lang="less">
	.buttonclass{
		margin-left: 133px;
	}
  .input-code {
    position: absolute;
    left: 132px;
    top: 12%;
    height: 30px;
  }
  .input-code .opt-a{
    display: block;
    width: 75px;
    height: 30px;
    line-height: 30px;
    background: #3eaef9;
    color: #fff;
    font-size: 12px;
    text-align: center;
  }
</style>


